module.exports = __webpack_public_path__ + "img/img_footer@2x.14330d25.png";